const trimTrailingSlash = (url) => (url || '').replace(/\/$/, '');

export const CORPORATE_SITE_URL = trimTrailingSlash(
  process.env.REACT_APP_CORPORATE_SITE_URL || 'https://flaretech.co.jp'
);

export const GRADUATE_SITE_URL = trimTrailingSlash(
  process.env.REACT_APP_GRADUATE_SITE_URL || 'https://graduates.recruit.flaretech.co.jp'
);

export const DEFAULT_OG_IMAGE_PATH = '/og-images/og-default.png';

function joinUrl(base, path = '') {
  if (!path) return base;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}

export function getSiteUrl() {
  if (process.env.REACT_APP_SITE_URL) {
    return trimTrailingSlash(process.env.REACT_APP_SITE_URL);
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return trimTrailingSlash(window.location.origin);
  }
  return '';
}

export function getAbsoluteUrl(path = '') {
  return joinUrl(getSiteUrl(), path);
}

export function getCorporateUrl(path = '') {
  return joinUrl(CORPORATE_SITE_URL, path);
}

export function getGraduateUrl(path = '') {
  return joinUrl(GRADUATE_SITE_URL, path);
}

export function getOgImageUrl(path = DEFAULT_OG_IMAGE_PATH) {
  const imagePath = path.startsWith('/') ? path : `/${path}`;
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  return getAbsoluteUrl(imagePath);
}
